import { useCallback, useRef, useState } from 'react';

interface TipState { x: number; y: number; text: string; open: boolean; }

export function useTooltip() {
    const [tip, setTip] = useState<TipState>({ x: 0, y: 0, text: '', open: false });
    const ref = useRef<HTMLDivElement>(null);

    const show = useCallback((clientX: number, clientY: number, text: string) => {
        setTip({ x: clientX, y: clientY, text, open: true });
    }, []);
    const hide = useCallback(() => setTip(t => ({ ...t, open: false })), []);

    const node = (
        <div
            ref={ref}
            role="tooltip"
            aria-hidden={!tip.open}
            style={{
                position: 'fixed', left: tip.x + 12, top: tip.y + 12, pointerEvents: 'none',
                background: 'rgba(20,22,26,0.94)', color: '#fff', padding: '6px 9px', borderRadius: 6,
                font: '12px/1.4 "Hanken Grotesk", sans-serif', zIndex: 1400,
                opacity: tip.open ? 1 : 0, transition: 'opacity .08s', maxWidth: 220,
            }}
        >
            {tip.text}
        </div>
    );

    return { show, hide, node };
}
